import parse from 'html-react-parser';
import { useSafariPackagesContext } from 'provider/SharePackagesProvider';

const GettingThere = () => {
    const { packageViewData } = useSafariPackagesContext();
    return (
            <div className="card bg-set accordion-collapse  card_bodyPadding">
                <div className="card-body p-3">
                    <div className="itenary-title">
                        <h6 className="fs-5 fw-bold pb-2">GETTING THERE</h6>
                    </div>
                    <div className="itenary_text inclusions">
                        {packageViewData?.getting_there && parse(packageViewData?.getting_there)}
                    </div>
                </div>
            </div>
    )
}

export default GettingThere;